import React, { useState, useMemo, useEffect,useRef } from "react";
import { Toast } from "primereact/toast";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import { Calendar } from "primereact/calendar";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import axios from "axios";
import "./BookingCalander.css";
import { IoClose } from "react-icons/io5";
import {
  bookSlot,
  getReservedslot
} from "../../Services/BackendUrl";
import { FaCheck } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import { encryptedAuth } from "../../Services/EncryptData";
import { Dropdown } from 'primereact/dropdown';

const isMidnight = (date) =>
  date && date.getHours() === 0 && date.getMinutes() === 0;

const getAdjustedEndTime = (start, end) => {
  if (!start || !end) return end;
  if (isMidnight(end) && end <= start) {
    const adjusted = new Date(end);
    adjusted.setDate(adjusted.getDate() + 1);
    return adjusted;
  }
  return end;
};

const BookingCalendar = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [bookedEvents, setBookedEvents] = useState([]);
  const [courtNo, setCourtNo] = useState(1);
  const availableCourts = [1, 2, 3, 4, 5, 6, 7];
  const [showDialog, setShowDialog] = useState(false);
  const basePrice = 0;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    playerCount: "",
    price: "",
    receipt: null,
  });
  const [errors, setErrors] = useState({});
  const toast = useRef(null);
    const [selectedType, setSelectedType] = useState(null);
    const types = [
        { name: 'Weekly Slot Booking (Excluding Friday & Saturday)', code: 'WEEKLY_EXCL_FRI_SAT' },
        { name: 'Weekly Slot Booking (Excluding Thursday & Friday)', code: 'WEEKLY_EXCL_THU_FRI' },
        { name: 'Weekly Slot Booking (7 DAYS)', code: 'WEEKLY_7_DAYS'},
        { name: 'Weekly Slot Booking (6 days Excl Friday)', code: 'WEEKLY_6_EXCL_FRI' },
        { name: 'Weekly Slot Booking (6 days Excl Thursday)', code: 'WEEKLY_6_EXCL_THU' },
        { name: 'Weekly Slot Booking (6 days Excl Saturday)', code: 'WEEKLY_6_EXCL_SAT' },
        { name: 'Weekened SLOT-1 (Friday & Saturday)', code: 'WEEKEND_SLOT1_FRI_SAT' },
        { name: 'Weekened SLOT-2 (Thursday & Friday)', code: 'WEEKEND_SLOT2_THU_FRI' },
        { name: 'Weekened SLOT-3 (Thursday & Saturday)', code: 'WEEKEND_SLOT3_THU_SAT' },
        { name: 'Weekened SLOT-4 (Thursday only)', code: 'WEEKEND_SLOT4_THU' },
        { name: 'Weekened SLOT-5 (Friday only)', code: 'WEEKEND_SLOT5_FRI' },
        { name: 'Weekened SLOT-6 (Saturday only)', code: 'WEEKEND_SLOT6_SAT' },
        { name: 'Coaching KIDS(7 Days)', code: 'COACHING_KIDS_7DAY' },
        { name: 'Coaching Adults(7 Days)', code: 'COACHING_ADULTS_7DAY' },
    ];

  const isAllFieldsFilled =
    courtNo && startDate && endDate && startTime && endTime && selectedType;

  const formatTo12HourString = (date) => {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const mins = minutes < 10 ? "0" + minutes : minutes;
    return `${hours.toString().padStart(2, "0")}:${mins}${ampm}`;
  };

  const formatDateWithoutTimezone = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getDateRange = (start, end) => {
    const range = [];
    const current = new Date(start);
    current.setHours(0, 0, 0, 0);
    const last = new Date(end);
    last.setHours(0, 0, 0, 0);
    return range;
  };

  const formatTo12Hour = (hour, minute) => {
    const period = hour >= 12 ? "pm" : "am";
    const hour12 = hour % 12 || 12;
    const minuteStr = minute.toString().padStart(2, "0");
    return `${hour12}:${minuteStr} ${period}`;
  };

  const normalizeToHour = (date) => {
    if (!date) return null;
    const d = new Date(date);
    d.setMinutes(0, 0, 0);
    return d;
  };

  const isInAllowedWindow = (date, { allowMidnight } = { allowMidnight: true }) => {
    if (!date) return false;
    const hours = date.getHours();
    const minutes = date.getMinutes();
    if (isMidnight(date)) return allowMidnight;
    if (minutes !== 0) return false;
    return hours >= 5 && hours <= 23;
  };

useEffect(() => {
  if (!basePrice || !startDate || !endDate || !startTime || !endTime) return;

  const adjustedEndTime = getAdjustedEndTime(startTime, endTime);
  const hoursDiff = Math.abs(adjustedEndTime - startTime) / (1000 * 60 * 60); 
  const daysDiff =
    Math.floor(
      (endDate.setHours(0, 0, 0, 0) - startDate.setHours(0, 0, 0, 0)) /
        (1000 * 60 * 60 * 24)
    ) + 1;

  const totalPrice = basePrice * hoursDiff * daysDiff;

  setFormData((prev) => ({
    ...prev,
    price: totalPrice.toFixed(2),
  }));
}, [basePrice, startDate, endDate, startTime, endTime]);

  const validateForm = () => {
    const newErrors = {};
    const nameRegex = /^[A-Za-z\s]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const numberRegex = /^[0-9]+$/;

    if (!formData.name.trim()) newErrors.name = "Full name is required";
    else if (!nameRegex.test(formData.name))
      newErrors.name = "Name must contain only letters";

    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!emailRegex.test(formData.email))
      newErrors.email = "Invalid email format";

    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";

    if (!formData.playerCount.trim())
      newErrors.playerCount = "Player count is required";
    else if (!numberRegex.test(formData.playerCount) || formData.playerCount <= 0)
      newErrors.playerCount = "Enter a valid number of players";

    if (!formData.price.trim()) newErrors.price = "Price is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleBookDates = () => {
  if (
    !isInAllowedWindow(startTime, { allowMidnight: false }) ||
    !isInAllowedWindow(endTime, { allowMidnight: true })
  ) {
   toast.current.show({
      severity: "custom",
      life: 4000,
      content: (
        <div
          style={{
            backgroundColor: "#FF7F5077",
            width: "100%",
            padding: "20px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "20px",
            alignItems: "center",
            color: "white",
            borderRadius: "6px",
          }}
        >
          <GrClose size={24} />
          <span className="font-medium">
            Start time must be between 5:00 AM and 11:00 PM. End time can be up to 12:00 AM.
          </span>
        </div>
      ),
    });
    return;
  }
  if (startDate > endDate) {
   toast.current.show({
      severity: "custom",
      life: 4000,
      content: (
        <div
          style={{
            backgroundColor: "#FF7F5077",
            width: "100%",
            padding: "20px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "20px",
            alignItems: "center",
            color: "white",
            borderRadius: "6px",
          }}
        >
          <GrClose size={24} />
          <span className="font-medium">
            Invalid Time Selection
          </span>
        </div>
      ),
    });
  }
 
    if (startTime >= endTime && !isMidnight(endTime)) {
   toast.current.show({
      severity: "custom",
      life: 4000,
      content: (
        <div
          style={{
            backgroundColor: "#FF7F5077",
            width: "100%",
            padding: "20px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "20px",
            alignItems: "center",
            color: "white",
            borderRadius: "6px",
          }}
        >
          <GrClose size={24} />
          <span className="font-medium">
            Invalid Time Selection
          </span>
        </div>
      ),
    });
    return;
  }
  setShowDialog(true);
};

const getReserved = async () => {
  try {
    const res = await axios.get(getReservedslot, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Encrypted ${encryptedAuth}`,
      },
    });

    const bookings = res.data.bookings;
    const events = [];

    bookings.forEach((booking) => {
      const { dates, from, to, courtNo } = booking;

    dates.forEach((date) => {
      events.push({
        title: `${from} - ${to} (Booked)`,
        start: `${date}T12:00:00`,
        end: `${date}T14:00:00`,
        courtNo: Number(courtNo),
        backgroundColor: "red",
        borderColor: "red",
      });
    });
    });

    setBookedEvents(events);
  } catch (error) {
    console.error("Error:", error);
  }
};
  useEffect(()=>{
    getReserved()
  },[])


  const handleSubmitBooking = async () => {
  if (!validateForm()) return;
  if (
    !isInAllowedWindow(startTime, { allowMidnight: false }) ||
    !isInAllowedWindow(endTime, { allowMidnight: true })
  ) return;
  if (isSubmitting) return;
  setIsSubmitting(true);

  try {
    const fromDate = formatDateWithoutTimezone(startDate);
    const toDate = formatDateWithoutTimezone(endDate);
    const from = formatTo12HourString(startTime);
    const to = formatTo12HourString(endTime);

    const bookingData = {
      courtNo: Number(courtNo),
      fromDate,
      toDate,
      from,
      to,
      fullName: formData.name,
      mobileNumber: formData.phone,
      email: formData.email,
      playerCount: parseInt(formData.playerCount),
      price: parseFloat(formData.price),
      bookingType : selectedType.code
    };

    const form = new FormData();
    form.append("data", JSON.stringify(bookingData));
    if (formData.receipt) {
      form.append("file", formData.receipt);
    }
    
    const response = await axios.post(
      bookSlot,
      form,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

     toast.current.show({
      severity: "custom",
      life: 4000,
      content: (
        <div
          style={{
            backgroundColor: "#63F52066",
            width: "100%",
            padding: "20px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "20px",
            alignItems: "center",
            color: "white",
            borderRadius: "6px",
          }}
        >
          <FaCheck size={24} />
          <span className="font-medium">
            {response.data.message || "Booking successful!"}
          </span>
        </div>
      ),
    });

    const dateRange = getDateRange(startDate, endDate);
    const newEvents = dateRange.map((d) => {
      const start = new Date(d);
      start.setHours(startTime.getHours(), startTime.getMinutes(), 0, 0);
      const end = new Date(d);
      end.setHours(endTime.getHours(), endTime.getMinutes(), 0, 0);
      if (isMidnight(endTime) && startTime >= endTime) {
        end.setDate(end.getDate() + 1);
      }

      return {
        title: `${formatTo12Hour(
          startTime.getHours(),
          startTime.getMinutes()
        )}-${formatTo12Hour(endTime.getHours(), endTime.getMinutes())} (booked)`,
        start: start.toISOString(),
        end: end.toISOString(),
        backgroundColor: "rgba(255,0,0,0.8)",
        borderColor: "red",
        courtNo,
      };
    });
    getReserved()
    setBookedEvents((prev) => [...prev, ...newEvents]);
    resetInputs();
    setShowDialog(false);
  } catch (error) {
    const errorMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    "Something went wrong";
    // console.error("❌ Booking failed:", error);

 toast.current.show({
      severity: "custom",
      life: 4000,
      content: (
        <div
          style={{
            backgroundColor: "#FF7F5077",
            width: "100%",
            padding: "20px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "20px",
            alignItems: "center",
            color: "white",
            borderRadius: "6px",
          }}
        >
          <GrClose size={24} />
          <span className="font-medium">
            {errorMessage}. The selected time is already booked.
            {/* booking failed. Please try again! */}
          </span>
        </div>
      ),
    });
  } finally {
    setIsSubmitting(false);
  }
};

  const resetInputs = () => {
    setStartDate(null);
    setEndDate(null);
    setStartTime(null);
    setEndTime(null);
    setFormData({
      name: "",
      email: "",
      phone: "",
      playerCount: "",
      price: "",
      receipt: null,
    });
    setErrors({});
  };

  const filteredEvents = useMemo(() => {
    if (!courtNo) return [];
    return bookedEvents.filter((b) => b.courtNo === courtNo);
  }, [bookedEvents, courtNo]);

  const handleStartTimeChange = (e) => {
    const value = normalizeToHour(e.value);
    if (!value) {
      setStartTime(null);
      return;
    }
    if (!isInAllowedWindow(value, { allowMidnight: false })) {
      toast.current.show({
        severity: "custom",
        life: 4000,
        content: (
          <div
            style={{
              backgroundColor: "#FF7F5077",
              width: "100%",
              padding: "20px",
              display: "flex",
              justifyContent: "flex-start",
              gap: "20px",
              alignItems: "center",
              color: "white",
              borderRadius: "6px",
            }}
          >
            <GrClose size={24} />
            <span className="font-medium">
              Start time must be between 5:00 AM and 11:00 PM.
            </span>
          </div>
        ),
      });
      return;
    }
    setStartTime(value);
  };

  const handleEndTimeChange = (e) => {
    const value = normalizeToHour(e.value);
    if (!value) {
      setEndTime(null);
      return;
    }
    if (!isInAllowedWindow(value, { allowMidnight: true })) {
      toast.current.show({
        severity: "custom",
        life: 4000,
        content: (
          <div
            style={{
              backgroundColor: "#FF7F5077",
              width: "100%",
              padding: "20px",
              display: "flex",
              justifyContent: "flex-start",
              gap: "20px",
              alignItems: "center",
              color: "white",
              borderRadius: "6px",
            }}
          >
            <GrClose size={24} />
            <span className="font-medium">
              End time must be between 5:00 AM and 12:00 AM.
            </span>
          </div>
        ),
      });
      return;
    }
    setEndTime(value);
  };

  return (
    <div className="calendar-container p-6 text-white">
      <Toast ref={toast} />
      <p className="text-3xl font-bold text-center mb-4 uppercase">
        Bulk Booking
      </p>

      <div className="flex justify-center mb-6">
        <select
          value={courtNo}
          onChange={(e) => setCourtNo(Number(e.target.value))}
          className="bg-transparent border border-gray-400 text-white px-4 py-2 rounded-md text-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
        >
          {availableCourts.map((num) => (
            <option key={num} value={num} className="text-black">
              Court {num}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-wrap justify-center gap-6 mb-6">
        <Calendar
          value={startDate}
          onChange={(e) => setStartDate(e.value)}
          dateFormat="dd-mm-yy"
          placeholder="Start Date"
          className="new-calendar"
          minDate={new Date()}
        />
        <Calendar
          value={endDate}
          onChange={(e) => setEndDate(e.value)}
          dateFormat="dd-mm-yy"
          placeholder="End Date"
          className="new-calendar"
          
          minDate={startDate || new Date()}
        />
        <Calendar
          value={startTime}
          onChange={handleStartTimeChange}
          timeOnly
          hourFormat="12"
          placeholder="Start Time"
          className="new-calendar"
          appendTo='self'
          stepMinute={60}
        />
        <Calendar
          value={endTime}
          onChange={handleEndTimeChange}
          timeOnly
          hourFormat="12"
          placeholder="End Time"
          className="new-calendar"
          appendTo='self'
          stepMinute={60}
        />
      </div>

      <div className="flex justify-center mb-6 gap-6">
      <Dropdown value={selectedType} onChange={(e) => setSelectedType(e.value)} options={types} optionLabel="name" dropdownIcon="pi pi-chevron-down"
                placeholder="Type" className="text-white border border-solid text-center flex items-center w-[200px]" />

        <button
          onClick={handleBookDates}
          disabled={!isAllFieldsFilled}
          className={`px-6 py-2 rounded-lg font-semibold transition ${
            isAllFieldsFilled
              ? "bg-orange-500 hover:bg-orange-600 text-white cursor-pointer border-none"
              : "bg-gray-600 text-gray-300 cursor-not-allowed"
          }`}
        >
          BOOK
        </button>
      </div>

      <FullCalendar
  plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
  initialView="dayGridMonth"
  headerToolbar={{
    left: "prev,next today",
    center: "title",
    right: "dayGridMonth,timeGridWeek,timeGridDay",
  }}
  slotMinTime="05:00:00"
  slotMaxTime="24:00:00"
  allDaySlot={false}
  events={filteredEvents}
  height="100vh"
  displayEventTime={false}
  initialDate={new Date()} 
 validRange={{
  start: `${new Date().getFullYear()}-01-01`,
  end: `${new Date().getFullYear() + 10}-12-31`,
}}

/>

      {showDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-[400px] p-6 relative animate-fadeIn">
            <button
              onClick={() => setShowDialog(false)}
              className="absolute  top-6 right-4 bg-transparent border-none cursor-pointer"
            >
              <IoClose size={30} />
            </button>

            <h2 className="text-2xl font-bold text-gray-900 mb-5">
              Booking Details
            </h2>

            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <label className="font-semibold text-gray-700">
                  Full Name*
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  placeholder="Enter full name"
                  className={`border rounded-md px-3 py-2 focus:ring-2 ${
                    errors.name
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-orange-500"
                  } outline-none`}
                />
                {errors.name && (
                  <span className="text-sm text-red-500">{errors.name}</span>
                )}
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold text-gray-700">Email*</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                  placeholder="Enter email"
                  className={`border rounded-md px-3 py-2 focus:ring-2 ${
                    errors.email
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-orange-500"
                  } outline-none`}
                />
                {errors.email && (
                  <span className="text-sm text-red-500">{errors.email}</span>
                )}
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold text-gray-700">
                  Phone Number*
                </label>
                <input
                  type="text"
                  value={formData.phone}
                  onChange={(e) =>
                    setFormData({ ...formData, phone: e.target.value })
                  }
                  placeholder="Enter the number"
                  onKeyPress={(e) => {  if (!/[0-9]/.test(e.key)) { e.preventDefault()}}}
                  // maxLength={10}
                  className={`border rounded-md px-3 py-2 focus:ring-2 ${
                    errors.phone
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-orange-500"
                  } outline-none`}
                />
                {errors.phone && (
                  <span className="text-sm text-red-500">{errors.phone}</span>
                )}
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold text-gray-700">
                  Player Count*
                </label>
                <input
                  type="number"
                  min={0}
                  value={formData.playerCount}
                  onChange={(e) =>
                    setFormData({ ...formData, playerCount: e.target.value })
                  }
                  placeholder="Enter player count"
                  className={`border rounded-md px-3 py-2 focus:ring-2 ${
                    errors.playerCount
                      ? "border-red-500 focus:ring-red-400"
                      : "focus:ring-orange-500"
                  } outline-none`}
                />
                {errors.playerCount && (
                  <span className="text-sm text-red-500">
                    {errors.playerCount}
                  </span>
                )}
              </div>

<div className="flex flex-col gap-2">
  <label className="font-semibold text-gray-700">Price (OMR)*</label>
  <input
    // type="number"
    // value={formData.price}
    // value={formData.playerCount}
    onChange={(e) =>
      setFormData({ ...formData, price: e.target.value })
    }
    // readOnly
    placeholder="Enter the price"
    onKeyPress={(e) => {  if (!/[0-9]/.test(e.key)) { e.preventDefault()}}}
    className="border rounded-md px-3 py-2 bg-gray-100 text-gray-700 outline-none"
  />
</div>

              <div className="flex flex-col gap-2">
                <label className="font-semibold text-gray-700">
                  Payment Receipt (optional)
                </label>
                <label className="cursor-pointer bg-blue-500 text-white px-4 py-2 rounded-md w-fit hover:bg-blue-600 transition">
                  Upload
                  <input
  type="file"
  accept=".pdf, image/jpeg, image/png"
  className="hidden"
  onChange={(e) =>
    setFormData({
      ...formData,
      receipt: e.target.files?.[0],
    })
  }
/>
                </label>
              </div>
            </div>

            <button
              onClick={handleSubmitBooking}
              disabled={isSubmitting}
              aria-busy={isSubmitting}
              className={`w-full mt-6 border-none text-white font-semibold py-3 rounded-md transition ${
                isSubmitting
                  ? "bg-orange-500 opacity-70 cursor-not-allowed"
                  : "bg-orange-500 hover:bg-orange-600 cursor-pointer"
              }`}
            >
              {isSubmitting ? "Submitting..." : "Submit Booking"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingCalendar;
